var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 180.363 56.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Ads\u0131z_degrade_2);}.cls-1,.cls-2,.cls-3,.cls-4{stroke-width:0px;}.cls-2{fill:#565656;}.cls-3{fill:url(#Ads\u0131z_degrade);}.cls-4{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ads\\u0131z_degrade",
    x1: -5382.288,
    y1: -610.004,
    x2: -5376.32,
    y2: -604.869,
    gradientTransform: "translate(15953.108 1835.144) scale(2.962 2.991)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a9fd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#306998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ads\\u0131z_degrade_2",
    x1: -5374.014,
    y1: -601.762,
    x2: -5376.145,
    y2: -604.777,
    gradientTransform: "translate(15953.108 1835.144) scale(2.962 2.991)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd43b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe873"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 180.363,
    height: 50
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.628,9.857c-1.321.006-2.583.119-3.693.315-3.27.578-3.864,1.787-3.864,4.018v2.946h7.728v.982h-10.629c-2.246,0-4.213,1.35-4.828,3.918-.71,2.944-.741,4.781,0,7.855.549,2.288,1.861,3.918,4.107,3.918h2.657v-3.531c0-2.551,2.207-4.801,4.828-4.801h7.719c2.149,0,3.864-1.769,3.864-3.927v-7.36c0-2.094-1.767-3.668-3.864-4.018-1.328-.221-2.705-.321-4.026-.315h0ZM24.449,12.226c.798,0,1.45.663,1.45,1.477s-.652,1.468-1.45,1.468-1.45-.656-1.45-1.468.649-1.477,1.45-1.477h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.483,18.117v3.432c0,2.661-2.256,4.9-4.828,4.9h-7.719c-2.115,0-3.864,1.81-3.864,3.927v7.359c0,2.095,1.821,3.327,3.864,3.927,2.446.719,4.792.849,7.719,0,1.946-.563,3.864-1.697,3.864-3.927v-2.945h-7.719v-.982h11.584c2.246,0,3.083-1.567,3.864-3.918.807-2.421.773-4.749,0-7.855-.555-2.236-1.615-3.918-3.864-3.918h-2.9ZM33.141,36.753c.801,0,1.45.656,1.45,1.468s-.649,1.477-1.45,1.477-1.45-.663-1.45-1.477.652-1.468,1.45-1.468Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.997,24.954c-.317.588-.816,1.062-1.494,1.422-.678.36-1.532.54-2.564.54h-2.106v4.824h-2.52v-12.564h4.626c.972,0,1.8.169,2.483.505.685.336,1.197.798,1.539,1.386.343.588.514,1.254.514,1.998,0,.672-.159,1.302-.478,1.89ZM64.377,24.405c.336-.317.504-.765.504-1.341,0-1.225-.684-1.836-2.052-1.836h-1.998v3.653h1.998c.696,0,1.212-.158,1.548-.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.795,21.768l-6.174,14.688h-2.683l2.16-4.968-3.996-9.72h2.826l2.574,6.966,2.609-6.966h2.683Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.08,23.837v4.824c0,.336.081.579.243.729.162.149.435.225.819.225h1.17v2.124h-1.584c-2.124,0-3.187-1.032-3.187-3.096v-4.807h-1.188v-2.069h1.188v-2.467h2.538v2.467h2.232v2.069h-2.232Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.761,22.119c.588.33,1.047.816,1.377,1.458.33.643.495,1.413.495,2.313v5.85h-2.521v-5.508c0-.792-.197-1.401-.594-1.827-.396-.426-.936-.639-1.62-.639-.696,0-1.245.213-1.646.639-.402.426-.604,1.035-.604,1.827v5.508h-2.52v-13.32h2.52v4.59c.324-.432.756-.771,1.296-1.017s1.141-.369,1.801-.369c.756,0,1.428.165,2.016.495Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.864,31.263c-.769-.426-1.371-1.029-1.81-1.81-.438-.779-.656-1.68-.656-2.7s.225-1.92.675-2.699c.45-.78,1.064-1.384,1.845-1.81s1.65-.639,2.61-.639,1.83.213,2.609.639c.78.426,1.396,1.029,1.846,1.81.45.779.675,1.68.675,2.699s-.231,1.921-.693,2.7c-.462.78-1.086,1.384-1.872,1.81s-1.665.639-2.637.639c-.96,0-1.824-.213-2.592-.639ZM104.743,29.372c.402-.222.723-.555.963-.999.24-.443.36-.983.36-1.62,0-.947-.249-1.677-.747-2.187s-1.107-.766-1.827-.766-1.323.256-1.809.766c-.486.51-.729,1.239-.729,2.187s.237,1.678.711,2.188,1.071.765,1.791.765c.456,0,.885-.11,1.287-.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.918,22.748c.731.75,1.098,1.798,1.098,3.142v5.85h-2.521v-5.508c0-.792-.197-1.401-.594-1.827-.396-.426-.936-.639-1.62-.639-.696,0-1.245.213-1.646.639-.402.426-.604,1.035-.604,1.827v5.508h-2.52v-9.972h2.52v1.241c.336-.432.766-.771,1.287-1.017.522-.246,1.095-.369,1.719-.369,1.188,0,2.148.375,2.881,1.125Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/Python.a326467084ba2106c6ca9cbce91c5d87.svg";
export { ForwardRef as ReactComponent };